import classNames from 'classnames'

import { Button } from '@saatva-bits/pattern-library.components.button'
import { SaatvaLogo, AffirmLogo } from '../../svgs'

import styles from './AffirmHeader.module.scss'

const AffirmHeader = () => {
    return (
        <section className={classNames('section section--alt2', styles.header)}>
            <div className="container">
                <div className="row row--center-xs">
                    <div className="col col--xs-12">
                        <div className={classNames(styles.content)}>
                            <div className="u-fullWidth u-flexDisplay u-flexDirection--row u-flexAlign--baseline u-flexJustify--center u-flexJustify--lg-flexStart">
                                <SaatvaLogo className={styles.saatvaLogo} />
                                <span className={styles.separator}>+</span>
                                <AffirmLogo className={styles.affirmLogo} />
                            </div>
                            <h1 className="t-headingHero t-color--white u-marginBottom--sm">Pay at your own pace with Affirm</h1>
                            <p className={classNames(styles.text, 't-bodyLg')}>
                                When inspiration strikes, Affirm helps you say yes without giving up financial control. Select Affirm at checkout to pay over time—and never pay a penny more than you agree to on day one.
                            </p>
                            <Button
                                kind="primary"
                                className="u-marginTop--lg affirm-site-modal"
                                data-page-type="landing"
                            >
                                Prequalify now
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AffirmHeader
